module.exports = __webpack_public_path__ + "static/media/newLife3.f7d310ac.jpg";